export function getSecondsLeft(timer: any): number {
    let secondsLeft = parseFloat(timer.attr("totalSecondsLeft"));
    if (!timer.attr("data-endingDate")) {
        const now = new Date();
        timer.attr(
            "data-endingDate",
            now.setSeconds(now.getSeconds() + secondsLeft)
        );
    }
    secondsLeft =
        (parseInt(timer.attr("data-endingDate")) - new Date().getTime()) / 1000;
    return secondsLeft;
}

export function setSecondsLeft(timer: any, value: number) {
    timer.attr("totalSecondsLeft", value);
}
